module.exports = __webpack_public_path__ + "img/2_1-commerciale-mercato-1.97bb997c.png";